import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import LoadingIndicator from '@scoir/components-core/dist/components/LoadingIndicator'

import SetMapPreference from './SetMapPreference'

import './index.scss'

export default class MapControlOverlay extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    showManualSearch: PropTypes.bool,
    onManualSearch: PropTypes.func.isRequired,
    onAfterGoToDefault: PropTypes.func.isRequired,
  }
  static defaultProps = {
    isLoading: false,
    showManualSearch: false,
  }
  render() {
    const isLoading = this.props.isLoading
    return (
      <div className="map-control-overlay-comp">
        <div className="map-control-overlay-card">
          <div className={cn('loading-wrapper', { loading: isLoading })}>
            <LoadingIndicator />
          </div>
          <div className={cn('search-wrapper', { show: this.props.showManualSearch && !isLoading })}>
            <button onClick={() => this.props.onManualSearch()}>Search this area</button>
          </div>
          <SetMapPreference onAfterGoToDefault={this.props.onAfterGoToDefault} />
        </div>
      </div>
    )
  }
}
